import React from 'react'
import { TimePicker } from '@mui/x-date-pickers/TimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import { colorThemes, Constants, GlobalConfig, I18n } from 'galarm-config'
import { useSelector } from 'react-redux'

const TimeInput = ({ value, onChange, ...timeInputProps }) => {
  const timeFormat = GlobalConfig.timeFormat || GlobalConfig.defaultTimeFormat
  const format =
    timeFormat === Constants.TimeFormats.TWELVE_HOUR_FORMAT ? 'h:mm A' : 'H:mm'
  const ampm = timeFormat === Constants.TimeFormats.TWELVE_HOUR_FORMAT
  const timeValue = value ? moment(value) : null

  const onTimeChange = date => {
    date && onChange(date.toDate())
  }

  const colorScheme = useSelector(state => state.userSettings.webColorScheme)
  const textColor = colorThemes.getColorTheme(colorScheme).textColor
  const borderColor = colorThemes.getColorTheme(colorScheme).darkTint

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TimePicker
        ampm={ampm}
        value={timeValue}
        onChange={onTimeChange}
        format={format}
        enableAccessibleFieldDOMStructure={false}
        slotProps={{
          textField: {
            size: 'small',
            placeholder: I18n.t('specifyTime'),
            sx: {
              // Text & icon colors
              '& .MuiInputBase-input': { color: textColor },
              '& .MuiInputLabel-root': { color: textColor },
              '& .MuiSvgIcon-root': { color: borderColor },

              // Border color
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: borderColor
                },
                '&:hover fieldset': {
                  borderColor: borderColor
                },
                '&.Mui-focused fieldset': {
                  borderColor: borderColor
                }
              }
            }
          }
        }}
        {...timeInputProps}
      />
    </LocalizationProvider>
  )
}

export default TimeInput
